import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get_AllAgent ,update_AgentsPricingData } from '../../../Service/Systemsetting/SystemsettingService'


export const getAllAgent = createAsyncThunk("getAllAgent", async (data) => {
    try {
        const res = await get_AllAgent(data);
        return await res;
    } catch (err) {
        return err;
    }
});

export const updateAgentsPricingData = createAsyncThunk("updateAgentsPricingData", async (data) => {
    try {
        const res = await update_AgentsPricingData(data);
        return await res;
    } catch (err) {
        return err;
    }
});


